export const EVENT_ROOM_VIEW_PANEL_CLOSE = 'onRoomViewPanelClose';
export const EVENT_ROOM_VIEW_PANEL_OPEN = 'onRoomViewPanelOpen';
export const EVENT_CAROUSEL_DATE_SELECT = 'onRoomViewPanelDateSelect';
export const EVENT_CRUISE_SEARCH_APPLY_FILTERS = 'onCruiseSearchApplyFilters';


export const MOBILE_OFFSET = 230;
export const DESKTOP_TABLET_OFFSET = 250;
